// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2sV0s","inputDescription":"styles_inputDescription__3sjHx"};